<template>
  <div class="footer">
    <!-- 合作伙伴 -->
    <div class="partner_wrap partner1">
      <div class="container5 content_w">
        <h2>合作伙伴</h2>
        <!-- Swiper -->
        <div class="swiper-container swiper-container3">
          <div class="swiper-wrapper">
            <!-- template -->
            <template v-for="item8 in returnIndex8(cooperateSource2)">
              <div class="swiper-slide">
                <div>
                  <Row
                    class="list"
                    :gutter="17"
                  >
                    <Col
                      class="list-item"
                      :xs="24"
                      :sm="6"
                      v-for="item in 4" :key="item"
                    >
                    <img
                      :src="cooperateSource2[item8-9+item].img"
                      alt
                      @click="openUrl(cooperateSource2[item8-9+item].url)"
                    >
                    </Col>
                  </Row>
                  <!--  -->
                  <Row
                    class="list"
                    :gutter="16"
                  >
                    <Col
                      class="list-item"
                      :xs="24"
                      :sm="6"
                      v-for="item in 4" :key="item"
                    >
                    <img
                      :src="cooperateSource2[item8-5+item].img"
                      alt
                      @click="openUrl(cooperateSource2[item8-9+item].url)"
                    >
                    </Col>
                  </Row>
                </div>
              </div>
            </template>
            <!-- template 有余数是最后一行-->
            <template v-if="cooperateSource2.length%8!=0">
              <div class="swiper-slide">
                <div style="width:100%;">
                  <Row
                    class="list"
                    :gutter="16"
                    v-if="(cooperateSource2.length%8<4)||(cooperateSource2.length%8==4)"
                  >
                    <Col
                      class="list-item"
                      :xs="24"
                      :sm="6"
                      v-for="item in (cooperateSource2.length%8)" :key="item"
                    >
                    <img
                      :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+item].img"
                      alt
                      @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+item].url)"
                    >
                    </Col>
                  </Row>
                  <template v-if="cooperateSource2.length%8>4">
                    <Row
                      class="list"
                      :gutter="16"
                    >
                      <Col
                        class="list-item"
                        :xs="24"
                        :sm="6"
                        v-for="item in 4" :key="item"
                      >
                      <img
                        :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+item].img"
                        alt
                        @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+item].url)"
                      >
                      </Col>
                    </Row>
                    <Row
                      class="list"
                      :gutter="16"
                    >
                      <Col
                        v-for="item in (cooperateSource2.length%8-4)" :key="item"
                        class="list-item"
                        :xs="24"
                        :sm="6"
                      >
                      <img
                        :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+4+item].img"
                        alt
                        @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%8)-1+4+item].url)"
                      >
                      </Col>
                    </Row>
                  </template>
                </div>
              </div>
            </template>
            <!-- template 有余数是最后一行-->
            <!-- template end -->

            <!-- <div class="swiper-slide">
              <div>
                <Row class="list" :gutter="16">
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p1.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p2.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p3.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p4.png" alt @click="openUrl()">
                  </Col>
                </Row>
                <Row class="list" :gutter="16">
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p5.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p6.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p7.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p8.png" alt @click="openUrl()">
                  </Col>
                </Row>
              </div>
            </div> -->
            <!--  -->
            <!-- <div class="swiper-slide">
              <div>
                <Row class="list" :gutter="16">
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p9.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p10.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p11.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p12.png" alt @click="openUrl()">
                  </Col>
                </Row>
                <Row class="list" :gutter="16">
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p13.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p14.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p15.png" alt @click="openUrl()">
                  </Col>
                  <Col class="list-item" :xs="24" :sm="6">
                    <img src="../assets/partner/p16.png" alt @click="openUrl()">
                  </Col>
                </Row>
              </div>
            </div> -->
            <!--  -->
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination swiper-pagination3"></div>
        </div>
        <!-- swipter end -->
      </div>
    </div>
    <!-- 合作伙伴 3end -->

    <!-- 合作伙伴 2-->

    <div class="partner_wrap partner2">
      <div class="container5 content_w">
        <h2>合作伙伴</h2>
        <!-- Swiper -->
        <div class="swiper-container swiper-container4">
          <div class="swiper-wrapper">
            <!-- template -->
            <template v-for="item6 in returnIndex6(cooperateSource2)">
              <div class="swiper-slide">
                <div style="width:100%;">
                  <Row
                    class="list"
                    :gutter="16"
                  >
                    <Col
                      class="list-item"
                      span="8"
                      v-for="item in 3" :key="item"
                    >
                    <img
                      :src="cooperateSource2[item6-7+item].img"
                      alt
                      @click="openUrl(cooperateSource2[item6-7+item].url)"
                    >
                    </Col>
                  </Row>
                  <Row
                    class="list"
                    :gutter="16"
                  >
                    <Col
                      class="list-item"
                      span="8"
                      v-for="item in 3" :key="item"
                    >
                    <img
                      :src="cooperateSource2[item6-4+item].img"
                      alt
                      @click="openUrl(cooperateSource2[item6-4+item].url)"
                    >
                    </Col>
                  </Row>
                </div>
              </div>
            </template>
            <!-- template 有余数是最后一行-->
            <template v-if="cooperateSource2.length%6!=0">
              <div class="swiper-slide">
                <div style="width:100%;">
                  <Row
                    class="list"
                    :gutter="16"
                    v-if="(cooperateSource2.length%6<3)||(cooperateSource2.length%6==3)"
                  >
                    <Col
                      class="list-item"
                      span="8"
                      v-for="item in (cooperateSource2.length%6)" :key="item"
                    >
                    <img
                      :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+item].img"
                      alt
                      @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+item].url)"
                    >
                    </Col>
                  </Row>
                  <template v-if="cooperateSource2.length%6>3">
                    <Row
                      class="list"
                      :gutter="16"
                    >
                      <Col
                        class="list-item"
                        span="8"
                        v-for="item in 3" :key="item"
                      >
                      <img
                        :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+item].img"
                        alt
                        @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+item].url)"
                      >
                      </Col>
                    </Row>
                    <Row
                      class="list"
                      :gutter="16"
                    >
                      <Col
                        class="list-item"
                        span="8"
                        v-for="item in (cooperateSource2.length%6-3)" :key="item"
                      >
                      <img
                        :src="cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+4+item].img"
                        alt
                        @click="openUrl(cooperateSource2[cooperateSource2.length-(cooperateSource2.length%6)-1+4+item].url)"
                      >
                      </Col>
                    </Row>
                  </template>
                </div>
              </div>
            </template>
            <!-- template 有余数是最后一行 -->

            <!-- template -->

            <!--  -->
            <!-- <div class="swiper-slide">
              <div style="width:100%;">
                <Row class="list" :gutter="16">
                  <Col class="list-item" span="8">
                    <img src="../assets/partner/p1.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p2.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p3.png" alt @click="openUrl()">
                  </Col>
                </Row>
                <Row class="list" :gutter="16">
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p4.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p5.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p6.png" alt @click="openUrl()">
                  </Col>
                </Row>
              </div>
            </div> -->
            <!--  -->
            <!-- <div class="swiper-slide">
              <div style="width:100%;">
                <Row class="list" :gutter="16">
                  <Col class="list-item" span="8">
                    <img src="../assets/partner/p7.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p8.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p9.png" alt @click="openUrl()">
                  </Col>
                </Row>
                <Row class="list" :gutter="16">
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p10.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p11.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p12.png" alt @click="openUrl()">
                  </Col>
                </Row>
              </div>
            </div> -->
            <!--  -->

            <!--  -->
            <!-- <div class="swiper-slide">
              <div style="width:100%;">
                <Row class="list" :gutter="16">
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p13.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p14.png" alt @click="openUrl()">
                  </Col>
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p15.png" alt @click="openUrl()">
                  </Col>
                </Row>
                <Row class="list" :gutter="16">
                  <Col span="8" class="list-item">
                    <img src="../assets/partner/p16.png" alt @click="openUrl()">
                  </Col>
                </Row>
              </div>
            </div> -->
            <!--  -->
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination swiper-pagination4"></div>
        </div>
        <!-- swipter end -->

      </div>
    </div>
    <!-- 合作伙伴 3end -->

    <!-- 底部 -->
    <div class="bottom_wrap">
      <!-- <img class="img_banner" src="../assets/index/bottom.png" alt=""> -->
      <div
        class="content_text"
        style
      >
        <!-- <li v-for="n in even4(numbers)">{{ n }}</li> -->

        <!-- <li v-for="n1 in returnIndex6(numbers2)">{{numbers2[n1-1]}}</li> -->
        <!-- <template v-for="book in even4(numbers)">
             w
           <template  v-for="n2 in 4"> 
             s
             <div>{{numbers[book-4+n2-1]}}</div>
             s
           </template> 
           w
           </template>
           <template v-if="numbers.length%4!=0">
             <div>R
               {{numbers.length%4}}
               <div v-for="i in numbers.length%4">
                 {{numbers[numbers.length-(numbers.length%4+1)+i]}}
               </div>
               R
             </div> -->
        <!-- </template> -->
        <Row class="list0">
          <Col
            span="24"
            :lg="{ span: 20, offset: 4 }"
          >
          <h2>
            <span>联系我们</span>
          </h2>
          </Col>
        </Row>
        <Row class="list1 list1_1">
          <Col
            span="4"
            offset="4"
            class="list_l"
            :xs="12"
            :sm="4"
          >
          <ul>
            <li>财富热线：020-85656490</li>
            <li>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：hr@jia-xin.cn</li>
            <li>
              公司地址：广州市天河区兴民路222号之三
              805室（部位：A）
            </li>
          </ul>
          </Col>
          <Col
            span="4"
            class="list_r"
            :xs="12"
            :sm="4"
          >
          <ul>
            <li @click="navLink('/aboutme')">公司简介</li>
            <li @click="navLink('/enterpriseDynamics')">相关案例</li>
            <li @click="navLink('/career')">招贤纳士</li>
            <li @click="navLink('/publicInfo')">公开信息披露</li>
          </ul>
          </Col>
        </Row>
        <Row class="list1 list1_2 content_w">
          <Col span="24">
          <ul>
            <li>财富热线：020-85656490</li>
            <li>邮&nbsp;&nbsp;&nbsp;&nbsp;箱：hr@jia-xin.cn</li>
            <li>
              公司地址：广州市天河区兴民路222号之三
              805室（部位：A）
            </li>
          </ul>
          </Col>
          <!-- 二维码 -->
          <Col span="10">
          <img
            class="qr"
            src="../assets/index/qr_public.png"
            alt
          >
          </Col>
          <Col
            span="10"
            offset="4"
          >
          <img
            class="qr"
            src="../assets/index/qr_kefu.png"
            alt
          >
          </Col>
          <!--  -->
          <Col span="24">
          <div class="introduct">
            <span
              @click="navLink('/aboutme')"
              class="span"
            >公司简介</span>
            <span class="nbsp">|</span>
            <span
              @click="navLink('/enterpriseDynamics')"
              class="span"
            >相关案例</span>
            <span class="nbsp">|</span>
            <span
              @click="navLink('/career')"
              class="span"
            >招贤纳士</span>
            <span class="nbsp">|</span>
            <span
              @click="navLink('/publicInfo')"
              class="span"
            >公开信息披露</span>
          </div>
          </Col>
        </Row>
        <Row class="list2">
          <Col span="24">
          <!-- <div class="b_text1">合作网站：广东中嘉正医精细健康管理有限公司</div> -->
          <div class="b_text2">CopyRight © 2018 嘉信保险经纪有限公司 版权所有
            <span
              style="cursor: pointer"
              @click="To(url)"
            >粤ICP备18102183号-1</span>
          </div>
          </Col>
        </Row>
      </div>
    </div>
    <!-- 底部end -->

    <!-- <div class="qrcode">
      <div class="container">
        <div class="bg"></div>
        <div class="imgWrap serviceImg">
          <div class="img"></div>
          <div class="text">微信客服</div>
        </div>
        <div class="imgWrap wxImg">
          <div class="img"></div>
          <div class="text">微信公众号</div>
        </div>
      </div>
    </div>
    <div class="container cooperate">
      <Row class="list">
        <Col :xs="8" :sm="6" :md="4" v-for='item in items' :key="item.id" class="list-item">
        <div @click="openUrl(item.url)">
          <img class="img" :src="item.img" />
          <div>{{item.name}}</div>
        </div>
        </Col>
      </Row>
    </div>
    <div class="copyright">
      <div class="cooperate-info">
        <span span="4" v-for="list in footerNav" :key="list.id" @click="navLink(list.url)">{{list.name}}</span>
      </div>
      <div class="ICP">
        CopyRight &copy 2018 嘉信保险经纪有限公司 版权所有 粤ICP备18102183号-1
      </div>
    </div>-->
  </div>
</template>

<script>
import zhongying from "../assets/cooperation/zhongying.png";
import zhongyi from "../assets/cooperation/zhongyi.png";
import anlian from "../assets/cooperation/anlian.png";
import guohua from "../assets/cooperation/guohua.png";
import kunlun from "../assets/cooperation/kunlun.png";
import pingan from "../assets/cooperation/pingan.png";
import xintai from "../assets/cooperation/xintai.png";
import yongcheng from "../assets/cooperation/yongcheng.png";
import gongyin from "../assets/cooperation/gongyin.png";
import hengan from "../assets/cooperation/hengan.png";
import shengming from "../assets/cooperation/shengming.png";
import taikang from "../assets/cooperation/taikang.png";

// zq
import p1 from "../assets/partner/p1.png";
import p2 from "../assets/partner/p2.png";
import p3 from "../assets/partner/p3.png";
import p4 from "../assets/partner/p4.png";
import p5 from "../assets/partner/p5.png";
import p6 from "../assets/partner/p6.png";
import p7 from "../assets/partner/p7.png";
import p8 from "../assets/partner/p8.png";
import p9 from "../assets/partner/p9.png";
import p10 from "../assets/partner/p10.png";
import p11 from "../assets/partner/p11.png";
import p12 from "../assets/partner/p12.png";
import p13 from "../assets/partner/p13.png";
import p14 from "../assets/partner/p14.png";
import p15 from "../assets/partner/p15.png";
import p16 from "../assets/partner/p16.png";
import p17 from "../assets/partner/p17.png";
import p18 from "../assets/partner/p18.png";
import p19 from "../assets/partner/p19.png"

import Swiper from "swiper";

var cooperateSource = [
  {
    id: 1,
    name: "华夏",
    img: "../assets/cooperation/xintai.png",
    url: "http://www.aviva-cofco.com.cn"
  },
  {
    id: 2,
    name: "太平洋",
    img: p2,
    url: " http://www.cpic.com.cn/xccbx/"
  },
  {
    id: 3,
    name: "恒大人寿",
    img: zhongyi,
    url: "http://www.generalichina.com/"
  },
  {
    id: 4,
    name: "中英03",
    img: anlian,
    url: "http://www.allianz.cn/"
  },
  {
    id: 5,
    name: "工银安盛",
    img: guohua,
    url: "http://www.95549.cn/"
  },
  {
    id: 6,
    name: "珠江人寿",
    img: kunlun,
    url: "http://www.kunlunhealth.com/"
  },
  {
    id: 7,
    name: "泰康",
    img: pingan,
    url: "http://baoxian.pingan.com/"
  },
  {
    id: 8,
    name: "信泰",
    img: xintai,
    url: "http://www.xintai.com/"
  },
  {
    id: 9,
    name: "恒安",
    img: yongcheng,
    url: "http://www.alltrust.com.cn"
  },
  {
    id: 10,
    name: "安联",
    img: gongyin,
    url: "https://www.icbc-axa.com/"
  },
  {
    id: 11,
    name: "中意",
    img: hengan,
    url: "http://e.pingan.com/"
  },
  {
    id: 12,
    name: "联合复星",
    img: shengming,
    url: "http://www.sino-life.com/"
  },
  {
    id: 13,
    name: "中国人保",
    img: taikang,
    url: "http://www.tk.cn/"
  },
  {
    id: 14,
    name: "中信人寿",
    img: shengming,
    url: "http://www.sino-life.com/"
  },
  {
    id: 15,
    name: "安心",
    img: shengming,
    url: "http://www.sino-life.com/"
  },
  {
    id: 16,
    name: "阳光",
    img: shengming,
    url: "http://www.sino-life.com/"
  },
  {
    id: 17,
    name: "富德生命",
    img: shengming,
    url: "http://www.sino-life.com/"
  }
];

var cooperateSource2 = [
  {
    id: 1,
    name: "华夏人寿保险股份有限公司",
    img: p1,
    slogan: "连接保险，让爱更简单",
    phone: "010-6963 0000",
    url: "http://www.ihxlife.com/?ozs=45270-2825&bd_vid=9493710455873030069"
  },
  {
    id: 2,
    name: "太平洋",
    img: p2,
    phone: "95500",
    slogan: "平时注入一滴水 难时拥有太平洋",
    url: " http://www.cpic.com.cn/xccbx/"
  },
  {
    phone: "400-636-8888",
    id: 3,
    name: "恒大人寿保险有限公司",
    img: p3,
    slogan: "恒守诚信,大爱保障",
    url: "http://www.lifeisgreat.com.cn"
  },
  {
    phone: "020-84108080-827",
    id: 4,
    name: "中英人寿保险",
    img: p4,
    slogan: "Care in Every Home(关爱万家)",
    url: "http://www.aviva-cofco.com.cn/website/"
  },
  {
    phone: "020-38780328",
    id: 5,
    name: "工银安盛人寿广东分公司",
    img: p5,
    slogan: "工信于银,安享至盛",
    url: "https://www.icbc-axa.com/"
  },
  {
    phone: "4006-833-866",
    id: 6,
    name: "珠江人寿",
    img: p6,
    slogan: "滋养生息,源远流长",
    url: "https://www.prlife.com.cn"
  },
  {
    phone: "40000-95522",
    id: 7,
    name: "泰康人寿",
    img: p7,
    slogan: "人生无价,泰康有请",
    url: "http://www.taikang.com/"
  },
  {
    phone: "0571-87116666",
    id: 8,
    name: "信泰人寿保险股份有限公司",
    img: p8,
    slogan: "信守金融报国,致力民安国泰",
    url: "http://www.xintai.com/"
  },
  {
    phone: "400-818-8699",
    id: 9,
    name: "恒安标准人寿保险有限公司",
    img: p9,
    slogan: "信守保准,恒安一生.",
    url: "http://www.hengansl.com/index.html"
  },
  {
    phone: "020-8396-6788",
    id: 10,
    name: "安联财产保险(中国)有限公司",
    img: p10,
    slogan: "您的信心来自安联的承诺",
    url: "https://www.allianz360.com/"
  },
  {
    phone: "010-58190017",
    id: 11,
    name: "中意人寿保险有限公司",
    img: p11,
    slogan: "中意人寿,一生中意",
    url: "http://www.generalichina.com/"
  },
  {
    phone: "4006-11-7777",
    id: 12,
    name: "复星联合健康保险股份有限公司",
    img: p12,
    slogan: "复星联合,健康中国",
    url: "http://www.fosun-uhi.com"
  },
  {
    phone: "4008895518",
    id: 13,
    name: "中国人民保险集团股份有限公司",
    img: p13,
    slogan: "人民保险造福人民",
    url: "http://www.picc.com"
  },
  {
    phone: "4008-838-838",
    id: 14,
    name: "中信保诚人寿保险有限公司",
    img: p14,
    slogan: "聆听所致,信诚所在",
    url: "http://www.citic-prudential.com.cn/index.aspx"
  },
  {
    phone: "95303",
    id: 15,
    name: "安心财产保险有限责任公司",
    img: p15,
    slogan: "安心保险,简单的保险",
    url: "https://www.95303.com"
  },
  {
    phone: "8610-58289999",
    id: 16,
    name: "阳光保险集团股份有限公司",
    img: p16,
    slogan: "让人们拥有更多的阳光",
    url: "http://www.sinosig.com"
  },
  {
    phone: "95535 / 4008-200-035",
    id: 17,
    name: "富德生命人寿保险股份有限公司",
    img: p17,
    slogan: "富韵风华,德伴同行",
    url: "http://www.sino-life.com"
  },
  {
    phone: "95549",
    id: 18,
    name: "国华人寿保险股份有限公司 ",
    img: p18,
    slogan: "让中国每个家庭拥有保障和幸福",
    url: "http://www.95549.cn"
  },
  {
    phone: "400-810-9339 ",
    id: 19,
    name: "瑞泰人寿保险有限公司",
    img: p19,
    slogan: "打造精致的、特色的、持续盈利的瑞泰人寿",
    url: "http://www.oldmutual-guodian.com"
  }
];

export default {
  name: "footer-content2",
  data() {
    return {
      url: "http://beian.miit.gov.cn",
      cooperateSource2: cooperateSource2,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      src: "static/img/index/qr_kefu.png",
      numbers2: [11, 22, 33, 44, 55, 66, 77, 88, 99, 100]
      // 正式环境
      // 测试环境
      // documentUrl: "http://static-test.jiahedev.com"
      // items: cooperateSource,
      // footerNav: footerNav
    };
  },
  methods: {
    To: function(url) {
      window.location.href = url;
    },
    even: function(numbers) {
      return numbers.filter(function(number) {
        return number % 2 === 0;
      });
    },
    //  目的每隔n位返回第n位的下标 因为下标要从1开始才能算得准确 所以最终返回的下标要减一
    returnIndex6: function(arry) {
      var length = arry.length;
      var lengthArr = [];
      for (var i = 1; i < length + 1; i++) {
        lengthArr.push(i);
      }
      // 　　　　return numbers.filter(function (number) {console.log(number);
      return lengthArr.filter(function(number) {
        return number % 6 === 0;
      });
    },
    //  目的每隔n位返回第n位的下标 因为下标要从1开始才能算得准确 所以最终返回的下标要减一
    returnIndex8: function(arry) {
      var length = arry.length;
      var lengthArr = [];
      for (var i = 1; i < length + 1; i++) {
        lengthArr.push(i);
      }
      // 　　　　return numbers.filter(function (number) {console.log(number);
      return lengthArr.filter(function(number) {
        return number % 8 === 0;
      });
    },
    openUrl: function(e) {
      // var target=event.target;
      // var dataid=e;//(pl.id的值);
      // $(target)//当前点击的dom
      window.location.href = e;
    },

    navLink: function(url) {
      if (url && url != "") {
        this.$router.push({ path: url });
      } else {
        window.location.href = "tel:020-66310600";
      }
    }
  },
  mounted() {
    var swiper3 = new Swiper(".swiper-container3", {
      pagination: {
        el: ".swiper-pagination3"
      }
      // loop: true,
      // autoplay: {
      //   disableOnInteraction: false
      // }
    });

    var swiper4 = new Swiper(".swiper-container4", {
      pagination: {
        el: ".swiper-pagination4"
      }
      // loop: true,
      // autoplay: {
      //   disableOnInteraction: false
      // }
    });
  }
};
</script>
<style scoped lang="less" src="../style/index.less"></style>
<style  lang="less">
.swiper-container2 {
  .swiper-pagination-bullet-active {
    background: #f3981b;
  }
}
</style>
<style scoped lang="less">
.footer {
  // 合作伙伴
  .partner1 {
    display: none;
  }
  .partner2 {
    display: block;
  }
  .partner_wrap {
    background: #f2f2f2;
    padding-top: 40px;
    h2 {
      margin: 0 auto 40px;
      color: #333;
      font-size: 30px;
      font-weight: normal;
      text-align: left;
    }
    .swiper-container {
      width: 100%;
      height: auto;
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        padding-bottom: 50px;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        .list {
          margin-bottom: 20px;
          &:nth-of-type(1) {
            // margin-bottom: 16px;
          }
          img {
            display: block;
            width: 100%;
            cursor: pointer;
          }
        }
      }
      .swiper-pagination-bullets {
        bottom: 30px;
        right: 0;
        text-align: right;
      }
    }
  }
  // 合作伙伴end
  // 底部
  .bottom_wrap {
    position: relative;
    background: url(../assets/index/bottom2.png) no-repeat;
    background-size: 100% 100%;
    .img_banner {
      display: block;
      width: 100%;
    }
    .content_text {
      // position: absolute;
      // top:0;
      // left:0;
      // right:0;
      // bottom:0;
      color: #fff;
      .list0 {
        text-align: center;
        h2 {
          font-size: 16px;
          font-weight: bold;
          position: relative;
          margin-bottom: 45px;
          margin-top: 45px;
          display: inline-block;
          span:before {
            position: absolute;
            width: 5px;
            content: "";
            background: #dead64;
            left: -12px;
            top: 4px;
            bottom: 4px;
            display: block;
          }
          // &:before {
          //   position: absolute;
          //   width: 5px;
          //   content: "";
          //   background: #dead64;
          //   left: -12px;
          //   top: 4px;
          //   bottom: 4px;
          //   display: block;
          // }
        }
      }
      .list1_1 {
        display: none;
      }
      .list1_2 {
        display: block;
      }
      .list1 {
        .list_r {
          ul {
            li:hover {
              cursor: pointer;
              color: #dead64;
            }
          }
        }

        ul {
          font-size: 14px;
          padding-left: 1em;
          li {
            list-style: none;
            margin-bottom: 12px;
            span {
              padding-left: 5em;
            }
          }
        }
        .qr {
          display: block;
          width: 60%;
          margin: 40px auto 0;
        }
        .introduct {
          color: #ffffff;
          font-size: 14px;
          text-align: center;
          margin: 60px auto 25px;
          .span:hover {
            cursor: pointer;
            color: #dead64;
          }
          .nbsp {
            margin: 0 10px;
          }
        }
      }
      .list2 {
        text-align: center;
        margin-top: 2%;
        .b_text1 {
          font-size: 14px;
          margin-bottom: 0.5em;
        }
        .b_text2 {
          font-size: 12px;
          color: #dddddd;
          margin-bottom: 0.5em;
        }
      }
    }
  }
  // 底部end

  // iview @media
  // xs
  @media (max-width: 768px) {
    .content_w {
      margin: 0 auto;
      width: 90%;
    }
    // 合作伙伴
    .partner_wrap {
      padding-top: 23px;
      h2 {
        font-size: 16px;
        text-align: center;
        font-weight: bold;
        margin: 0 auto 18px;
      }
      .swiper-container {
        .swiper-slide {
          .list {
            margin-bottom: 10px;
            &:nth-of-type(1) {
              margin-bottom: 0px;
            }
            .list-item {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
    // 合作伙伴end

    // 底部
    .bottom_wrap {
      .content_text {
        .list1 {
          .introduct {
            .nbsp {
              margin: 0 7px;
            }
          }
        }
      }
    }
  }
  // sm
  @media (min-width: 768px) {
    .content_w {
      margin: 0 auto;
      width: 74%;
    }
    // 合作伙伴
    .partner_wrap {
      padding-top: 23px;
      h2 {
        font-size: 16px;
        text-align: center;
        font-weight: bold;
        margin: 0 auto 18px;
      }
      .swiper-container {
        .swiper-slide {
          .list {
            margin-bottom: 10px;
            .list-item {
              // border-bottom: 1px solid #D7D7D7;
              // margin-bottom: 12px;
            }
          }
        }
      }
    }
    // 合作伙伴end
  }
  // md
  @media (min-width: 992px) {
    .content_w {
      margin: 0 auto;
      width: 70%;
    }
    // 合作伙伴
    .partner_wrap {
      h2 {
        font-size: 30px;
        text-align: left;
        font-weight: normal;
      }
      .swiper-container {
        .swiper-slide {
          .list {
            margin-bottom: 16px;
          }
        }
      }
    }
  }
  // lg
  @media (min-width: 1200px) {
    .content_w {
      margin: 0 auto;
      width: 56%;
    }
    // 合作伙伴
    .partner_wrap {
      h2 {
        font-size: 30px;
        text-align: left;
        font-weight: normal;
      }
    }
    .swiper-container {
      .swiper-slide {
        .list {
          margin-bottom: 16px;
        }
      }
    }
    // 合作伙伴
    .partner1 {
      display: block;
    }
    .partner2 {
      display: none;
    }

    // 底部
    .bottom_wrap {
      position: relative;
      background: url(../assets/index/bottom.png) no-repeat;
      background-size: 100% 100%;
      .img_banner {
        display: block;
        width: 100%;
      }
      .content_text {
        // position: absolute;
        // top:0;
        // left:0;
        // right:0;
        // bottom:0;
        color: #fff;
        .list0 {
          text-align: left;
          h2 {
            display: block;
            font-size: 20px;
            font-weight: normal;
            position: relative;
            margin-bottom: 2%;
            margin-top: 1%;
            span:before {
              position: absolute;
              width: 5px;
              content: "";
              background: #dead64;
              left: -12px;
              top: 4px;
              bottom: 4px;
              display: block;
            }
            &:before {
              position: absolute;
              width: 5px;
              content: "";
              background: #dead64;
              left: -12px;
              top: 4px;
              bottom: 4px;
              display: block;
            }
          }
        }
        .list1_1 {
          display: block;
        }
        .list1_2 {
          display: none;
        }
        .list1 {
          ul {
            font-size: 14px;
            padding-left: 1em;
            li {
              list-style: none;
              margin-bottom: 12px;
              span {
                padding-left: 5em;
              }
            }
          }
        }
        .list2 {
          text-align: center;
          margin-top: 2%;
          .b_text1 {
            font-size: 16px;
            margin-bottom: 0.5em;
          }
          .b_text2 {
            font-size: 12px;
            color: #dddddd;
            margin-bottom: 0.5em;
          }
        }
      }
    }
    // 底部end
  }

  .qrcode {
    background: url(../assets/qrCode.png) no-repeat;
    background-size: cover;
    height: 180px;
    position: relative;
    &:after {
      display: inline-block;
      clear: both;
      overflow: hidden;
      content: "";
    }

    @media screen and(min-width:768px) {
      .container {
        width: 750px;
        height: 180px;
        position: absolute;
        right: 0;
        top: 0;
        .bg {
          width: 100%;
          height: 180px;
          background-color: #f3981b;
          opacity: 0.8;
        }
        .imgWrap {
          &.wxImg {
            left: 36px;
          }
          &.serviceImg {
            left: 216px;
          }
        }
      }
    }
    @media screen and(max-width: 767px) {
      .container {
        .imgWrap {
          &.wxImg {
            right: 10px;
          }
          &.serviceImg {
            right: 170px;
          }
        }
      }
    }
    .imgWrap {
      width: 140px;
      height: 160px;
      position: absolute;
      top: 50%;
      margin-top: -80px;
      .text {
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        margin-top: 4px;
      }
      .img {
        width: 140px;
        height: 140px;
      }
      &.wxImg {
        .img {
          background: url("../assets/qrcode.jpg") no-repeat;
          background-size: cover;
        }
      }
      &.serviceImg {
        .img {
          background: url("../assets/serviceCode.jpg") no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .cooperate {
    overflow: hidden;
    .list {
      text-align: center;
      .list-item {
        margin-top: 10px;
        padding-right: 10px;
        .img {
          height: 50px;
          border: 1px solid #eaeaea;
          margin-bottom: 5px;
        }
      }
    }
  }
  .copyright {
    .cooperate-info {
      padding: 30px 0 10px;
      text-align: center;
      span {
        display: inline-block;
        padding: 0 5px;
        border-right: 1px solid #eaeaea;
      }
      :last-child {
        border-right: none;
      }
    }
    .ICP {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterContent2.vue